import {Component, OnInit} from '@angular/core';
import {CpProvisionContractBaseComponent} from '../base/cp-provision-contract-base.component';

/**
 * Full view of the Provisionszeile OBC (`uiMode = 'full'`).
 *
 * Inherits the `navigationItems` from {@link CpProvisionContractBaseComponent} and renders exactly
 * ONE shared detail component per active navigation item. No business logic, no form HTML.
 */
@Component({
    selector: 'cp-provision-contract-full',
    templateUrl: './cp-provision-contract-full.component.html',
    styleUrls: ['./cp-provision-contract-full.component.scss'],
    standalone: false
})
export class CpProvisionContractFullComponent extends CpProvisionContractBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
